import {
  LOADERTRUE,
  LOADERFALSE,
  FETCH_COUNTRY_REQUEST,
  FETCH_COUNTRY_SUCCESS,
  FETCH_COUNTRY_FAILURE,
  FETCH_STATES_REQUEST,
  FETCH_STATES_SUCCESS,
  FETCH_STATES_FAILURE,
  SHOWALERTFALSE,
  SHOWALERTTRUE,
  SET_ROUTE,
} from "../actions/CommonActions";

const initialState = {
  loader: false,
  countries: [],
  states: [],
  alert: false,
  route: "",
};

export const commonReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_COUNTRY_REQUEST:
    case FETCH_STATES_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_COUNTRY_SUCCESS:
      return { ...state, loading: false, countries: action.payload };

    case FETCH_STATES_SUCCESS:
      return { ...state, loading: false, states: action.payload };

    case FETCH_COUNTRY_FAILURE:
    case FETCH_STATES_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case LOADERTRUE:
      return {
        ...state,
        loader: true,
      };
    case LOADERFALSE:
      return {
        ...state,
        loader: false,
      };
    case SHOWALERTFALSE:
      return {
        ...state,
        alert: false,
      };
    case SHOWALERTTRUE:
      return {
        ...state,
        alert: true,
      };
    case SET_ROUTE:
      return {
        ...state,
        route: action.payload,
      };
    default:
      return state;
  }
};
